const LoadmoreFunction = () => {
    let currentPage = 1;
    let currentUrlParams = new URLSearchParams(window.location.search);
    function getTotalPages() {
        const paginationList = document.querySelectorAll('.pagination__list li');
        let totalPages = 1;
        paginationList.forEach(li => {
            let pageLink = li.querySelector('a');
            if (pageLink && !isNaN(parseInt(pageLink.innerText))) {
                totalPages = Math.max(totalPages, parseInt(pageLink.innerText));
            }
        });
        return totalPages;
    }
    function resetPagination() {
        currentPage = 1;
        currentUrlParams = new URLSearchParams(window.location.search);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setTimeout(function() {
            totalPages = getTotalPages();
        }, 2000);
    }
    let totalPages = getTotalPages();
    function fetchNextPage() {
        const productGrid = document.querySelector('#product-grid');
        const loadingSpinner = document.querySelector('.cate-grid #loadmore .loading__spinner');
        if (currentPage >= totalPages) {
            const loadMoreButton = document.getElementById('loadmore');
            loadMoreButton.style.display = 'none';
            return;
        }
        currentPage++;
        loadingSpinner.style.cssText = 'display: block !important;';
        const url = new URL(window.location.href);
        url.searchParams.set('page', currentPage);
        const nextPageUrl = url.toString();
        fetch(nextPageUrl)
            .then(response => response.text())
            .then(html => {
                let tempDiv = document.createElement('div');
                tempDiv.innerHTML = html;
                let newProducts = tempDiv.querySelectorAll('#product-grid .grid__item');
                newProducts.forEach(product => {
                    productGrid.appendChild(product);
                });
                const stickyHeader = document.querySelector('sticky-header');
                if (stickyHeader && stickyHeader.sync) {
                    setTimeout(() => {
                        stickyHeader.sync(); 
                    }, 50);
                }
                loadingSpinner.style.cssText = 'display: none;';
                if (currentPage >= totalPages) {
                    const loadMoreButton = document.getElementById('loadmore');
                    loadMoreButton.style.display = 'none';
                }
            })
            .catch(error => {
                console.error('Error fetching next page:', error);
                loadingSpinner.style.cssText = 'display: none;';
            });
    }
    setInterval(function() {
        const newUrlParams = new URLSearchParams(window.location.search);
        if (currentUrlParams.toString() !== newUrlParams.toString()) {
            resetPagination();
        }
    }, 500);
    document.addEventListener('click', function(event) {
        if (event.target.closest('#loadmore')) {
            fetchNextPage();
        }
    });
}
document.addEventListener('DOMContentLoaded', function() {
    let isMobileView = window.innerWidth < 750;
    if (isMobileView) LoadmoreFunction();
    window.addEventListener('resize', function() {
        const currentMobileView = window.innerWidth < 750;
        if (currentMobileView !== isMobileView) {
            isMobileView = currentMobileView;
            let url = new URL(window.location.href);
            url.searchParams.delete('page');
            window.location.href = url.toString();
        }
    });
});